import EmployeesGroups from '../components/templates/employees-groups';

export const EmployeesGroupsContainer = () => {
  return <EmployeesGroups />;
};
